import { DATE_TIME_FORMAT } from 'utils/constants';
import { dayjs } from 'utils/providers/Timezone';
import { Meta } from 'utils/types';

type PROPS = {
  _id: string;
  createdAt: string;
  updatedAt: string;
  linkedinUrl: string;
  [key: string]: any;
};

const company = ({
  data: { _id, createdAt, updatedAt, ...rest },
}: {
  data: PROPS;
}) => ({
  data: {
    ...rest,
    id: _id,
    phoneNumber: '+1 832-732-3486',
    createdAt: dayjs(createdAt).format(DATE_TIME_FORMAT),
    updatedAt: dayjs(updatedAt).format(DATE_TIME_FORMAT),
  },
});

const companies = ({ data, meta }: { data: PROPS[]; meta: Meta }) => ({
  meta,
  data: data.map((dat: PROPS) => company({ data: dat })?.data),
});

export default { company, companies };
